export const CALL_TREATMENTS = ['normal', 'vip', 'screen', 'block'];
export const CONTACT_VISIBILITIES = ['shared', 'private'];
export const CONTACT_KINDS = ['person', 'company'];
//# sourceMappingURL=contact.js.map